<template>
  <div class="antialiased">
    <Sidebar />

    <div class="page">
      <Header hint="Cari" :enabled="false" />

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">Posisi Stock</h2>
                <span>
                  {{ data_compile[0] ? data_compile[0].nama_gudang : "" }}
                </span>
              </div>

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto">
                    <button
                      class="btn btn-white ml-3"
                      v-html="ic('filter') + ' Filter'"
                      @click="triggerFilter"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="alert alert-info row">
            <div class="col-6">
              <i class="fe fe-info mr-2"></i> Warning Big Data Detected, load
              file may cause browser not work!
            </div>
            <div class="col-6" style="text-align: right">
              Data Loaded :
              {{ saldoAwal.length }} / {{ data_laporan.saldo_awal.length }}
            </div>
          </div>
          <div class="box">
            <Skeleton
              type="table"
              :length="9"
              class="mt-3 bg-white"
              v-if="loading"
            />
            <div
              v-if="saldoAwal.length > 0 && !loading"
              style="margin-button: 20px; padding: 0 0 20px 0px"
            >
              <div style="text-align: center; margin-button: 20px">
                <span>
                  <button
                    class="btn btn-primary"
                    v-if="!showed"
                    @click="
                      _compile();
                      showed = true;
                    "
                  >
                    <i class="fa fa-eye" aria-hidden="true"></i>
                    <span style="margin-left: 10px">Show Anyway</span>
                  </button>
                </span>
                <span style="margin-right: 20px">
                  <button
                    class="btn btn-primary"
                    v-if="showed"
                    @click="showed = false"
                  >
                    <i class="fa fa-eye-slash" aria-hidden="true"></i>
                    <span style="margin-left: 10px">Hide Anyway</span>
                  </button>
                </span>
                <span style="margin-right: 20px">
                  <button
                    class="btn btn-secondary"
                    v-if="is_detailed"
                    @click="_download()"
                  >
                    <i class="fa fa-arrow-down" aria-hidden="true"></i>
                    <span style="margin-left: 10px">Just Download</span>
                  </button>
                </span>
              </div>
            </div>
            <div
              class="card"
              v-if="data_compile.length > 0 && !loading && showed"
            >
              <div>
                <div class="input-icon">
                  <span
                    class="input-icon-addon"
                    v-html="isLoadMore ? spin() : ic('search')"
                  >
                    <i class="fe fe-search"></i>
                  </span>
                  <input
                    type="text"
                    placeholder="Cari..."
                    class="form-control"
                    v-model="data_filter.search"
                  />
                </div>
                <div
                  id="detail_table"
                  class="table-responsive"
                  style="max-height: 68vh"
                  @scroll="_scroll"
                >
                  <table
                    class="
                      table table-vcenter table-hover
                      card-table
                      table-striped table-no-break
                    "
                  >
                    <thead>
                      <tr>
                        <th style="background-color: white" title="Nomor">
                          No
                        </th>
                        <th
                          style="background-color: white"
                          title="Kode Barang"
                          scope="row_cop"
                        >
                          Kode Barang
                          <span v-if="data_filter.id_gudang.length != 1">
                            / Gudang</span
                          >
                        </th>
                        <th style="background-color: white" title="Nama Barang">
                          Nama Barang
                        </th>
                        <th
                          style="background-color: white"
                          title="SALDO FISIK DARI TANGGAL SEBELUMNYA, SALDO FISIK BUKAN SALDO AKHIR!!"
                        >
                          Saldo Awal
                        </th>
                        <th
                          style="background-color: white"
                          title="PENERIMAAN BARANG YANG SUDAH DI APPROVE"
                        >
                          Pembelian
                        </th>
                        <th
                          style="background-color: white"
                          title="MUTASI MASUK YANG SUDAH DI RECEIVED"
                        >
                          Mutasi Masuk
                        </th>
                        <th
                          style="background-color: white"
                          title="MUTASI KELUAR YANG SUDAH DI RECEIVED"
                        >
                          Mutasi Keluar
                        </th>
                        <th
                          style="background-color: white"
                          title="MUTASI YANG SUDAH DI APPROVE / ON THE WAY TAPI BELUM DI RECEIVED"
                          v-if="is_detailed"
                        >
                          Mutasi Masuk Pending
                        </th>
                        <th
                          style="background-color: white"
                          title="MUTASI YANG SUDAH DI APPROVE / ON THE WAY TAPI BELUM DI RECEIVED"
                          v-if="is_detailed"
                        >
                          Mutasi Keluar Pending
                        </th>
                        <th
                          style="background-color: white"
                          title="PENJUALAN YANG DIAPPROVE PADA RENTANG WAKTU TERPILIH"
                          v-if="is_detailed"
                        >
                          Approved
                        </th>
                        <th
                          style="background-color: white"
                          title="PENJUALAN YANG DILOADING PADA RENTANG WAKTU TERPILIH"
                          v-if="is_detailed"
                        >
                          Loaded
                        </th>
                        <th
                          style="background-color: white"
                          title="PENJUALAN YANG DIDELIVER PADA RENTANG WAKTU TERPILIH"
                        >
                          Delivered
                        </th>
                        <th
                          style="background-color: white"
                          title="RETUR PENJUALAN YANG DI APPROVE PADA RENTANG WAKTU TERPLIH"
                        >
                          Returned
                        </th>
                        <th
                          style="background-color: white"
                          title="SEMUA PENJUALAN DENGAN STATUS APPROVED SEBELUM TANGGAL AKHIR"
                          v-if="is_detailed"
                        >
                          All Transaction Pending
                        </th>
                        <th
                          style="background-color: white"
                          title="SEMUA PENJUALAN DENGAN STATUS LOADED SEBELUM TANGGAL AKHIR"
                          v-if="is_detailed"
                        >
                          All Transaction Loaded
                        </th>
                        <th
                          style="background-color: white"
                          title="ADJUSTMENT YANG DIAPPROVE PADA TANGGAL TERPILIH"
                        >
                          Adjustment
                        </th>
                        <th
                          style="background-color: white"
                          title="SALDO AWAL + PEMBELIAN + MUTASI MASUK - MUTASI KELUAR + MUTASI PENDING - PENJUALAN APPROVED - PENJUALAN LOADED - DELIVERED + RETUR - ALL PENDING - ALL LOADED + ADJUSMENT"
                          v-if="is_detailed"
                        >
                          Saldo Akhir
                        </th>
                        <th
                          style="background-color: white"
                          title="SALDO AKHIR - MUTASI PENDING + APPROVED + ALL PENDING"
                        >
                          Saldo Fisik
                        </th>
                        <th style="background-color: white" title="Harga">
                          Harga
                        </th>
                        <th
                          style="background-color: white"
                          title="SALDO AKHIR X HARGA"
                        >
                          Nilai Stock
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, i) in data_compile" :key="i">
                        <td nowrap title="No">{{ i + 1 }}</td>
                        <th
                          nowrap
                          style="font-weight: 500; background-color: white"
                          title="Kode Barang"
                          scope="row"
                        >
                          {{ row.kode_barang }}
                          <span v-if="data_filter.id_gudang.length != 1">
                            {{ row.nama_gudang }}
                          </span>
                        </th>
                        <td nowrap title="Nama Barang">
                          {{ row.nama_barang }}
                        </td>
                        <td nowrap title="Saldo Awal">
                          {{ row.qty_saldo_awal | currency }} /
                          {{ row.qty_pcs_saldo_awal | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          @click="
                            _getDetail(row, 'penerimaan barang', {
                              qty: row.qty_penerimaan_barang,
                              qty_pcs: row.qty_pcs_penerimaan_barang,
                            })
                          "
                          title="Pembelian"
                        >
                          {{ row.qty_penerimaan_barang | currency }} /
                          {{ row.qty_pcs_penerimaan_barang | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          @click="
                            _getDetail(row, 'mutasi masuk', {
                              qty: row.qty_penerimaan_barang,
                              qty_pcs: row.qty_pcs_penerimaan_barang,
                            })
                          "
                          title="Mutasi Masuk"
                        >
                          {{ row.qty_mutasi_masuk | currency }} /
                          {{ row.qty_pcs_mutasi_masuk | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          @click="
                            _getDetail(row, 'mutasi keluar', {
                              qty: row.qty_penerimaan_barang,
                              qty_pcs: row.qty_pcs_penerimaan_barang,
                            })
                          "
                          title="Mutasi Keluar"
                        >
                          {{ row.qty_mutasi_keluar | currency }} /
                          {{ row.qty_pcs_mutasi_keluar | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          title="Mutasi Pending"
                          v-if="is_detailed"
                        >
                          {{ row.qty_mutasi_masuk_pending | currency }} /
                          {{ row.qty_pcs_mutasi_masuk_pending | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          title="Mutasi Pending"
                          v-if="is_detailed"
                        >
                          {{ row.qty_mutasi_keluar_pending | currency }} /
                          {{ row.qty_pcs_mutasi_keluar_pending | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          title="Penjualan Approved"
                          v-if="is_detailed"
                        >
                          {{ row.qty_penjualan_approved | currency }} /
                          {{ row.qty_pcs_penjualan_approved | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          title="Penjualan Loaded"
                          v-if="is_detailed"
                        >
                          {{ row.qty_penjualan_loaded | currency }} /
                          {{ row.qty_pcs_penjualan_loaded | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          title="Penjualan Delivered"
                        >
                          {{ row.qty_penjualan_delivered | currency }} /
                          {{ row.qty_pcs_penjualan_delivered | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          @click="
                            _getDetail(row, 'retur', {
                              qty: row.qty_penerimaan_barang,
                              qty_pcs: row.qty_pcs_penerimaan_barang,
                            })
                          "
                          title="Retur"
                        >
                          {{ row.qty_retur | currency }} /
                          {{ row.qty_pcs_retur | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          title="All Transaction Pending"
                          v-if="is_detailed"
                        >
                          {{ row.qty_pending_all | currency }} /
                          {{ row.qty_pcs_pending_all | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          title="All Transaction Loaded"
                          v-if="is_detailed"
                        >
                          {{ row.qty_loaded_all | currency }} /
                          {{ row.qty_pcs_loaded_all | currency }}
                        </td>
                        <td
                          nowrap
                          class="click-able text-primary"
                          @click="
                            _getDetail(row, 'adjustment', {
                              qty: row.qty_penerimaan_barang,
                              qty_pcs: row.qty_pcs_penerimaan_barang,
                            })
                          "
                          title="Adjustment"
                        >
                          {{ row.qty_adjustment | currency }} /
                          {{ row.qty_adjustment | currency }}
                        </td>
                        <td nowrap title="Saldo Akhir" v-if="is_detailed">
                          {{ row.qty_saldo_akhir | currency }} /
                          {{ row.qty_pcs_saldo_akhir | currency }}
                        </td>
                        <td nowrap title="Saldo Fisik">
                          {{ row.qty_saldo_fisik | currency }} /
                          {{ row.qty_pcs_saldo_fisik | currency }}
                        </td>
                        <td nowrap title="Harga">{{ row.harga | currency }}</td>
                        <td nowrap title="Nilai Stock">
                          {{ row.nilai_stock | currency }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FormFilter />
    <Detail />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import { mapActions, mapState } from "vuex";
import FormFilter from "./modals/filter.vue";
import Detail from "./modals/detail.vue";

export default {
  name: "MonitoringOta",
  components: {
    FormFilter,
    Detail,
  },

  data() {
    return {
      progress: {
        barang: false,
        gudang: false,
        saldo_awal: false,
        penjualan: false,
        stock: false,
        mutasi: false,
      },
      loading: false,
      showed: false,
      barang: {},
      gudang: {},
      stock: {},
      scroled: 1,
      mutasi: [],
      penjualan: [],
      saldoAwal: [],
      data_compile: [],
      is_detailed: true,

      objects: [
        {
          foo: "bar",
          bar: "sit",
        },
        {
          foo: "lorem",
          bar: "ipsum",
        },
        {
          foo: "dolor",
          bar: "amet",
        },
      ],
    };
  },

  mixins: [helper],

  computed: {
    ...mapState("posisi_stock", {
      data_filter: (state) => state.data_filter,
      data_laporan: (state) => state.data_laporan,
      data_detail: (state) => state.data_detail,
      proses: (state) => state.proses,
    }),
  },
  methods: {
    ...mapActions("posisi_stock", [
      "triggerFilter",
      "triggerDetail",
      "getSaldoAwal",
      "getStock",
      "getPenjualan",
      "getMutasi",
      "getDetail",
      "getTipe",
    ]),
    ...mapActions("cache", ["getCacheBarang", "getCacheGudang"]),
    async _getChaceBarang() {
      if (localStorage.getItem("chaceBarang") === null) {
        await this.getCacheBarang().then((res) => {
          localStorage.removeItem("chaceBarang");
          localStorage.chaceBarang = JSON.stringify(res);
        });
      }
      await this._setChaceBarang();
    },
    _setChaceBarang() {
      this.barang = JSON.parse(localStorage.chaceBarang);
    },
    async _getChaceGudang() {
      if (localStorage.getItem("chaceGudang") === null) {
        await this.getCacheGudang().then((res) => {
          localStorage.removeItem("chaceGudang");
          localStorage.chaceGudang = JSON.stringify(res);
        });
      }
      await this._setChaceGudang();
    },
    _setChaceGudang() {
      this.gudang = JSON.parse(localStorage.chaceGudang);
    },
    async _getTipe() {
      await this.getTipe().then((res) => {
        this.is_detailed = res;
      });
    },
    async _getStock() {
      await this.getStock().then((res) => {
        this.stock = res;
      });
    },
    async _getPenjualan() {
      await this.getPenjualan().then((res) => {
        this.penjualan = res;
      });
    },
    async _getMutasi() {
      await this.getMutasi().then((res) => {
        this.mutasi = res;
      });
    },
    _getQty(id_barang, id_gudang, referensi, status) {
      let stock = this.stock;
      return parseFloat(
        stock[id_barang]
          ? stock[id_barang][id_gudang]
            ? stock[id_barang][id_gudang][referensi]
              ? stock[id_barang][id_gudang][referensi][status]
                ? stock[id_barang][id_gudang][referensi][status][0].qty
                : 0
              : 0
            : 0
          : 0
      );
    },
    _fetchPenjualan(id_barang, id_gudang, status) {
      let penjualan = this.penjualan;
      return penjualan[id_barang]
        ? penjualan[id_barang][id_gudang]
          ? penjualan[id_barang][id_gudang][status]
            ? penjualan[id_barang][id_gudang][status][0]
            : { qty: 0, qty_pcs: 0 }
          : { qty: 0, qty_pcs: 0 }
        : { qty: 0, qty_pcs: 0 };
    },
    _fetchMutasi(id_barang, id_gudang, $tipe) {
      let mutasi = this.mutasi[$tipe];
      return mutasi[id_barang]
        ? mutasi[id_barang][id_gudang]
          ? mutasi[id_barang][id_gudang][0]
          : { qty: 0, qty_pcs: 0 }
        : { qty: 0, qty_pcs: 0 };
    },
    _scroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.scroled++;
        if (this.saldoAwal.length < this.data_laporan.saldo_awal.length) {
          this.saldoAwal = this.data_laporan.saldo_awal.slice(
            0,
            this.scroled * 100
          );
          this._compile();
        }
      }
    },
    _getSaldoAwal() {
      this.getSaldoAwal().then((res) => {
        this.saldoAwal = res.slice(0, 100);
      });
    },
    _scrollStart() {
      document.getElementById("detail_table").scrollTop += 35;
    },
    _formatQty(qty, isi) {
      let real = qty;
      let res = Math.floor(Math.abs(qty) / isi);
      return real < 0 ? 0 - res : res;
    },
    _formatQtyPcs(qty, isi) {
      return qty % isi;
    },
    _compile() {
      let saldoAwal = this.saldoAwal;
      let gudang = this.gudang;
      let barang = this.barang;
      let compileALL = [];
      for (let i = 0; i < saldoAwal.length; i++) {
        const row = saldoAwal[i];
        let compile = {};
        let row_barang = barang[row.id_barang][0];
        let row_gudang = gudang[row.id_gudang][0];
        let isi = parseFloat(row_barang.isi);

        let fetched_mutasi_pending_keluar = this._fetchMutasi(
          row.id_barang,
          row.id_gudang,
          "mutasi_keluar"
        );
        let fetched_mutasi_pending_masuk = this._fetchMutasi(
          row.id_barang,
          row.id_gudang,
          "mutasi_masuk"
        );

        let fetched_penjualan_all_approved = this._fetchPenjualan(
          row.id_barang,
          row.id_gudang,
          "approved"
        );
        let fetched_penjualan_all_loaded = this._fetchPenjualan(
          row.id_barang,
          row.id_gudang,
          "loaded"
        );

        let qty_mutasi_pending_masuk = fetched_mutasi_pending_masuk.qty;
        let qty_pcs_mutasi_pending_masuk = fetched_mutasi_pending_masuk.qty_pcs;

        let qty_mutasi_pending_keluar = fetched_mutasi_pending_keluar.qty;
        let qty_pcs_mutasi_pending_keluar =
          fetched_mutasi_pending_keluar.qty_pcs;

        let qty_penjualan_all_approved = fetched_penjualan_all_approved.qty;
        let qty_pcs_penjualan_all_approved =
          fetched_penjualan_all_approved.qty_pcs;

        let qty_penjualan_all_loaded = fetched_penjualan_all_loaded.qty;
        let qty_pcs_penjualan_all_loaded = fetched_penjualan_all_loaded.qty_pcs;

        let penjualan_all_approved =
          parseFloat(qty_penjualan_all_approved) * isi +
          parseFloat(qty_pcs_penjualan_all_approved);
        let penjualan_all_loaded =
          parseFloat(qty_penjualan_all_loaded) * isi +
          parseFloat(qty_pcs_penjualan_all_loaded);
        let mutasi_masuk_pending =
          parseFloat(qty_mutasi_pending_masuk) * isi +
          parseFloat(qty_pcs_mutasi_pending_masuk);
        let mutasi_keluar_pending =
          parseFloat(qty_mutasi_pending_keluar) * isi +
          parseFloat(qty_pcs_mutasi_pending_keluar);

        let penerimaan_barang = this._getQty(
          row.id_barang,
          row.id_gudang,
          "penerimaan barang",
          "approved"
        );
        let mutasi_masuk = this._getQty(
          row.id_barang,
          row.id_gudang,
          "mutasi masuk",
          "received"
        );
        let adjustment = this._getQty(
          row.id_barang,
          row.id_gudang,
          "adjustment",
          "approved"
        );
        let mutasi_keluar = this._getQty(
          row.id_barang,
          row.id_gudang,
          "mutasi keluar",
          "received"
        );
        let penjualan_approved = this._getQty(
          row.id_barang,
          row.id_gudang,
          "penjualan",
          "approved"
        );
        let penjualan_loaded = this._getQty(
          row.id_barang,
          row.id_gudang,
          "penjualan",
          "loaded"
        );
        let penjualan_delivered = this._getQty(
          row.id_barang,
          row.id_gudang,
          "penjualan",
          "delivered"
        );
        let retur = this._getQty(
          row.id_barang,
          row.id_gudang,
          "retur",
          "approved"
        );

        let saldo_fisik =
          parseFloat(row.qty) +
          penerimaan_barang +
          mutasi_masuk +
          adjustment -
          mutasi_keluar -
          penjualan_delivered +
          retur;

        let saldo_akhir =
          saldo_fisik -
          penjualan_all_approved -
          penjualan_all_loaded +
          (mutasi_masuk_pending - mutasi_keluar_pending);

        compile["id_gudang"] = row.id_gudang;
        compile["nama_gudang"] = row_gudang.nama_gudang;
        compile["id_barang"] = row.id_barang;
        compile["kode_barang"] = row_barang.kode_barang;
        compile["nama_barang"] = row_barang.nama_barang;
        compile["harga"] = row_barang.harga;

        compile["qty_saldo_awal"] = this._formatQty(row.qty, isi);
        compile["qty_pcs_saldo_awal"] = this._formatQtyPcs(row.qty, isi);

        compile["qty_penerimaan_barang"] = this._formatQty(
          penerimaan_barang,
          isi
        );
        compile["qty_pcs_penerimaan_barang"] = this._formatQtyPcs(
          penerimaan_barang,
          isi
        );

        compile["qty_mutasi_masuk"] = this._formatQty(mutasi_masuk, isi);
        compile["qty_pcs_mutasi_masuk"] = this._formatQtyPcs(mutasi_masuk, isi);

        compile["qty_adjustment"] = this._formatQty(adjustment, isi);
        compile["qty_pcs_adjustment"] = this._formatQtyPcs(adjustment, isi);

        compile["qty_mutasi_keluar"] = this._formatQty(mutasi_keluar, isi);
        compile["qty_pcs_mutasi_keluar"] = this._formatQtyPcs(
          mutasi_keluar,
          isi
        );

        compile["qty_penjualan_approved"] = this._formatQty(
          penjualan_approved,
          isi
        );
        compile["qty_pcs_penjualan_approved"] = this._formatQtyPcs(
          penjualan_approved,
          isi
        );

        compile["qty_penjualan_loaded"] = this._formatQty(
          penjualan_loaded,
          isi
        );
        compile["qty_pcs_penjualan_loaded"] = this._formatQtyPcs(
          penjualan_loaded,
          isi
        );

        compile["qty_penjualan_delivered"] = this._formatQty(
          penjualan_delivered,
          isi
        );
        compile["qty_pcs_penjualan_delivered"] = this._formatQtyPcs(
          penjualan_delivered,
          isi
        );

        compile["qty_retur"] = this._formatQty(retur, isi);
        compile["qty_pcs_retur"] = this._formatQtyPcs(retur, isi);

        compile["qty_retur"] = this._formatQty(retur, isi);
        compile["qty_pcs_retur"] = this._formatQtyPcs(retur, isi);

        compile["qty_pending_all"] = this._formatQty(
          penjualan_all_approved,
          isi
        );
        compile["qty_pcs_pending_all"] = this._formatQtyPcs(
          penjualan_all_approved,
          isi
        );

        compile["qty_loaded_all"] = this._formatQty(penjualan_all_loaded, isi);
        compile["qty_pcs_loaded_all"] = this._formatQtyPcs(
          penjualan_all_loaded,
          isi
        );

        compile["qty_saldo_akhir"] = this._formatQty(saldo_akhir, isi);
        compile["qty_pcs_saldo_akhir"] = this._formatQtyPcs(saldo_akhir, isi);

        compile["qty_saldo_fisik"] = this._formatQty(saldo_fisik, isi);
        compile["qty_pcs_saldo_fisik"] = this._formatQtyPcs(saldo_fisik, isi);

        compile["qty_mutasi_masuk_pending"] = this._formatQty(
          mutasi_masuk_pending,
          isi
        );
        compile["qty_pcs_mutasi_masuk_pending"] = this._formatQtyPcs(
          mutasi_masuk_pending,
          isi
        );

        compile["qty_mutasi_keluar_pending"] = this._formatQty(
          mutasi_keluar_pending,
          isi
        );
        compile["qty_pcs_mutasi_keluar_pending"] = this._formatQtyPcs(
          mutasi_keluar_pending,
          isi
        );

        compile["nilai_stock"] = row_barang.harga * (saldo_fisik / isi);

        compileALL.push(compile);
      }
      console.log(compileALL);
      this.data_compile = compileALL;
    },
    _download() {
      this.showed = false;
      this.saldoAwal = this.data_laporan.saldo_awal;
      this._compile();
      this.createExcel({
        data: this.data_compile,
        filename: "Posisi Stock Lite - " + this.dTime("datetime"),
      });
      this.saldoAwal = this.data_laporan.saldo_awal.slice(
        0,
        this.scroled * 100
      );
    },
    _loadingSetter(status) {
      this.loading = status;
    },
    _clearData() {
      (this.showed = false), (this.barang = {});
      this.gudang = {};
      this.stock = {};
      this.scroled = 1;
      this.mutasi = [];
      this.penjualan = [];
      this.saldoAwal = [];
      this.data_compile = [];
    },
    async _getDetail(data, referensi, total) {
      this.data_detail.referensi = referensi;
      this.data_detail.nama_gudang = data.nama_gudang;
      this.data_detail.nama_barang = data.nama_barang;
      this.data_detail.kode_barang = data.kode_barang;
      this.data_detail.total = total;
      this.getDetail({
        referensi: referensi,
        id_barang: data.id_barang,
        id_gudang: data.id_gudang,
        start_date: this.data_filter.start_date,
        end_date: this.data_filter.end_date,
      }).then((res) => {
        this.triggerDetail();
      });
    },
    async _getAllData() {
      await this._clearData();
      await this._getTipe();
      await this._loadingSetter(true);
      await this._getChaceBarang();
      await this._getChaceGudang();
      await this._getSaldoAwal();
      await this._getPenjualan();
      await this._getStock();
      await this._getMutasi();
      await this._loadingSetter(false);
    },
  },
  watch: {
    proses: function () {
      if (this.proses) {
        this._getAllData();
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped src="./posisi-stock.scss"/>